// ============================================================
// 📁 آدرس این فایل در پروژه:
//    src/App.tsx
// 
// این فایل را در همان مسیر بالا کپی کنید (روی فایل قبلی بنویسید)
// ============================================================

import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AppProvider } from "./context/AppContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import Dashboard from "./pages/dashboard/Dashboard";
import Management from "./pages/management/Management";
import Finance from "./pages/finance/Finance";
import HR from "./pages/hr/HR";
import Customers from "./pages/customers/Customers";
import Vendors from "./pages/vendors/Vendors";
import Warehouse from "./pages/warehouse/Warehouse";
import Tracking from "./pages/tracking/Tracking";
import Users from "./pages/users/Users";
import Reports from "./pages/reports/Reports";
import Chat from "./pages/chat/Chat";
import Backup from "./pages/backup/Backup";
import Auth from "./pages/auth/Auth";
import SystemSettings from "./pages/settings/SystemSettings";
import President from "./pages/president/President";

export default function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/auth" element={<Auth />} />
          <Route path="/" element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<ProtectedRoute page="dashboard"><Dashboard /></ProtectedRoute>} />
            <Route path="president" element={<ProtectedRoute page="president"><President /></ProtectedRoute>} />
            <Route path="management" element={<ProtectedRoute page="management"><Management /></ProtectedRoute>} />
            <Route path="finance" element={<ProtectedRoute page="finance"><Finance /></ProtectedRoute>} />
            <Route path="hr" element={<ProtectedRoute page="hr"><HR /></ProtectedRoute>} />
            <Route path="customers" element={<ProtectedRoute page="customers"><Customers /></ProtectedRoute>} />
            <Route path="vendors" element={<ProtectedRoute page="vendors"><Vendors /></ProtectedRoute>} />
            <Route path="warehouse" element={<ProtectedRoute page="warehouse"><Warehouse /></ProtectedRoute>} />
            <Route path="tracking" element={<ProtectedRoute page="production"><Tracking /></ProtectedRoute>} />
            <Route path="users" element={<ProtectedRoute page="users"><Users /></ProtectedRoute>} />
            <Route path="reports" element={<ProtectedRoute page="reports"><Reports /></ProtectedRoute>} />
            <Route path="chat" element={<ProtectedRoute page="chat"><Chat /></ProtectedRoute>} />
            <Route path="backup" element={<ProtectedRoute page="backup"><Backup /></ProtectedRoute>} />
            <Route path="settings" element={<ProtectedRoute page="settings"><SystemSettings /></ProtectedRoute>} />
          </Route>
          <Route path="*" element={<Navigate to="/auth" replace />} />
        </Routes>
      </BrowserRouter>
    </AppProvider>
  );
}